import Image from "next/image";
import Link from "next/link";

import { RightArrowIcon } from "@/components/data-display/icon";

function BlogCard({ data }) {
  return (
    <Link
      href={`/blogs/${data?.slug}`}
      className="rounded-xl md:hover:bg-grayDisplay-450"
    >
      <div className="w-full cursor-pointer">
        <div className="relative aspect-[16/10]">
          <Image
            fill
            alt={data?.title}
            src={data?.thumbnail}
            className="rounded-xl object-cover"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            quality={40}
          />
        </div>
        <div className="py-[1.5rem] md:px-[1.25rem]">
          <p className="mb-[1.125rem] text-grayDisplay-300">
            {data?.published_date}
          </p>
          <h3 className="mb-2 line-clamp-2 text-[1.375rem] font-medium">
            {data?.title}
          </h3>
          <p className="mb-[1.5rem] line-clamp-2">{data?.short_description}</p>
          <div className="flex items-center gap-[0.25rem]">
            <p className="font-medium text-primary hover:underline">
              READ MORE
            </p>
            <RightArrowIcon className="h-[1.25rem] w-[1rem]" />
          </div>
        </div>
      </div>
    </Link>
  );
}

export default BlogCard;
